
import { Button } from "@/components/ui/button";
import { Eye, MinusCircle } from "lucide-react";
import { useWorkoutPlanSubscriptions } from "@/hooks/useWorkoutPlanSubscriptions";
import { toast } from "@/hooks/use-toast";
interface PlanCardProps {
  plan: {
    id: string;
    name: string;
    description?: string;
    is_personal?: boolean;
  };
  onViewRoutines: (planId: string) => void;
  onUnsubscribe?: (planId: string) => void;
  isUnsubscribing?: boolean;
}
export const PlanCard = ({
  plan,
  onViewRoutines,
  onUnsubscribe,
  isUnsubscribing
}: PlanCardProps) => {
  const {
    unsubscribeMutation
  } = useWorkoutPlanSubscriptions();
  const handleUnsubscribe = async () => {
    try {
      await unsubscribeMutation.mutateAsync(plan.id);
      if (onUnsubscribe) {
        onUnsubscribe(plan.id);
      }
      toast({
        title: "Plan cancelado",
        description: "Te has desinscrito del plan de entrenamiento correctamente."
      });
    } catch (error) {
      console.error('Error al desinscribirse del plan:', error);
      toast({
        variant: "destructive",
        title: "Error",
        description: "No se pudo cancelar la suscripción al plan de entrenamiento"
      });
    }
  };
  return <div className={`dark:bg-zinc-800 bg-primary/20 backdrop-blur-lg rounded-xl p-4 border ${plan.is_personal ? 'dark:border-gray-600 border-primary' : 'dark:border-gray-600 border-primary'}`}>
      <div className="flex flex-col h-full">
        <div className="flex-grow">
          <h3 className="text-lg font-semibold mb-2">{plan.name}</h3>
          {plan.description && <p className="text-sm text-foreground mb-4 dark:text-white/70">
              {plan.description}
            </p>}
        </div>
        
        <div className="space-y-2">
          <Button variant="outline" onClick={() => onViewRoutines(plan.id)} className="w-full bg-black/10 border-white/20 text-foreground hover:bg-primary/10 hover:text-black dark:hover:bg-white/10 dark:hover:text-white ocean:text-white forest:hover:bg-black/50 forest:hover:text-white ocean:hover:bg-background/50 sunset:hover:bg-white/10">
            <Eye className="mr-2 h-4 w-4" />
            Ver Rutinas
          </Button>

          {!plan.is_personal && <Button variant="outline" onClick={handleUnsubscribe} className="w-full border-white/20 hover:bg-white/10 bg-primary hover:bg-primary/60 text-white" disabled={isUnsubscribing || unsubscribeMutation.isPending}>
              <MinusCircle className="mr-2 h-4 w-4" />
              {unsubscribeMutation.isPending ? "Cancelando..." : "Cancelar Suscripción"}
            </Button>}
        </div>
      </div>
    </div>;
};
